import { On3IconAlert, On3IconTransferRating } from '@on3/icons';
import { Check } from '@on3/ui-lib/components/Svg';
import clsx from 'clsx';
import { EarlyEnrolleeIcon } from 'components/Icons/EarlyEnrolleeIcon';
import { EarlySigneeIcon } from 'components/Icons/EarlySigneeIcon';

import styles from './InterestLegend.module.scss';

interface InterestLegendProps {
  className?: string;
}
export const InterestLegend = ({ className }: InterestLegendProps) => {
  return (
    <figure
      className={clsx(styles.legend, className)}
      data-ui="interest-legend"
    >
      <figcaption>Legend</figcaption>
      <ul>
        <li>
          <EarlyEnrolleeIcon />
          Early enrollee
        </li>
        <li>
          <EarlySigneeIcon />
          Early signee
        </li>
        <li>
          <Check className={styles.checkmark} />
          Signed letter of intent
        </li>
        <li>
          <On3IconAlert />
          Short-term Signee
        </li>
        <li>
          <On3IconTransferRating height={20} />
          Transfer Rating
        </li>
      </ul>
    </figure>
  );
};
